import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { InnovatorsCarousel } from "../components/InnovatorsCarousel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const field = "w-full bg-[#2c6052] border border-[#4a3b31] rounded-md px-4 py-3 text-[#f3ece1] text-sm outline-none focus:border-[#ebc754] placeholder:text-[#8a7968]";

const ITINERARY = [
  ["5:45pm", "Arrival & drinks", "Drinks from BAA BAA Bar, time to settle into the house and meet a few people before we begin."],
  ["6:15pm", "Welcome", "A short welcome from Tom and an introduction to how the evening works."],
  ["6:25pm", "Plate one", "The first small plate from Grace & James and the first new conversation of the evening."],
  ["6:55pm", "Plate two", "Another plate. Another person. Another conversation."],
  ["7:25pm", "The FERAL Conversation", "An informal conversation between Tom and Robin from Dylan's, followed by questions from the room."],
  ["7:55pm", "Plate three", "The final savoury plate and another opportunity to sit down with someone different."],
  ["8:25pm", "Dessert & open house", "Dessert is served and the structure disappears. Go back to someone you met earlier, find somebody new, or head home whenever suits you."],
  ["9:00pm", "Official finish", "No rush out of the door. BAA BAA Bar stays open a little longer. The house closes around 9:30–10:00pm."],
];

const InnovatorsInvite = () => {
  const { token } = useParams();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState("");
  const [rooms, setRooms] = useState({});
  const [f, setF] = useState({ name: "", email: "", mobile: "", company: "", dietary: "", job_title: "", website: "", linkedin: "", instagram: "", building: "", useful_connection: "", can_help: "", partner_name: "", emergency_contact: "", newsletter_consent: false, photo_consent: false, accept_terms: false });
  const [accommodation, setAccommodation] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const [personal, setPersonal] = useState(false);

  useEffect(() => {
    const open = () => axios.get(`${API}/innovators/booking`)
      .then((r) => { setInvite({ valid: true }); setRooms(r.data.rooms || {}); })
      .catch(() => setError("Booking is unavailable right now."));
    if (!token) { open(); return; }
    axios.get(`${API}/innovators/invite/${token}`)
      .then((r) => { setPersonal(true); setInvite(r.data); setRooms(r.data.rooms || {}); setF((p) => ({ ...p, name: r.data.name || "", email: r.data.email || "" })); })
      .catch((e) => { if (e?.response?.status === 404) open(); else setError(e?.response?.data?.detail || "This invitation is no longer available."); });
  }, [token]);

  const pay = async (e) => {
    e.preventDefault();
    if (!f.name.trim() || !f.email.trim() || !f.mobile.trim() || !f.company.trim()) { setError("Please complete the required fields."); return; }
    if (!f.photo_consent) { setError("Please confirm you're happy to be photographed to book your place."); return; }
    if (!f.accept_terms) { setError("Please accept the booking terms."); return; }
    setSubmitting(true); setError("");
    try {
      const { data } = await axios.post(`${API}/innovators/checkout`, { token: personal ? token : null, origin: window.location.origin, accommodation: accommodation || null, ...f });
      window.location.href = data.url;
    } catch (err) { setSubmitting(false); setError(err?.response?.data?.detail || "Could not start checkout."); }
  };

  if (error && !invite) return (
    <div className="bg-[#2c6052] min-h-screen text-[#f3ece1] flex flex-col items-center justify-center px-6 text-center">
      <h1 className="feral-serif text-4xl text-[#f0dbbe] mb-3">Invitation not available</h1>
      <p className="text-[#c9bcab] max-w-md mb-6">{error}</p>
      <p className="text-[#9c8c7a] text-sm">Please get in touch with the FERAL team if you think this is a mistake.</p>
    </div>
  );
  if (!invite) return <div className="bg-[#2c6052] min-h-screen" />;

  if (invite.booked) return (
    <div className="bg-[#2c6052] min-h-screen text-[#f3ece1] flex flex-col items-center justify-center px-6 text-center">
      <h1 className="feral-serif text-4xl text-[#f0dbbe] mb-3">You're already confirmed</h1>
      <p className="text-[#c9bcab] max-w-md">This invitation has already been used to confirm a place. See you on Tuesday 10 November.</p>
    </div>
  );

  const total = 49 + (rooms[accommodation]?.price || 0);

  return (
    <div className="bg-[#2c6052] min-h-screen text-[#f3ece1]">
      <Navbar tone="sunset" />
      {/* HERO */}
      <section className="relative h-[70vh] min-h-[440px] overflow-hidden">
        <img src="/innov-hero.jpg" alt="Bron Menai Manor" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2c6052] via-[#2c6052]/55 to-[#2c6052]/30" />
          <div className="absolute inset-x-0 top-0 h-36 bg-gradient-to-b from-black/80 to-transparent" />
        <div className="absolute inset-0 flex flex-col justify-end px-6 pb-12">
          <div className="max-w-5xl mx-auto w-full">
            <p className="text-[#ebc754] tracking-[0.28em] text-xs font-bold uppercase mb-3" data-testid="invite-badge">You're invited</p>
            <h1 className="feral-serif text-[#ebc754] text-5xl sm:text-7xl leading-[0.9] mb-3">FERAL Innovators</h1>
            <p className="text-[#e7d9c6] text-lg sm:text-xl mb-3">For people building interesting things in North Wales.</p>
            <p className="text-[#c9bcab] text-sm tracking-[0.08em]">Tuesday 10 November · 5:45pm–9:00pm · Bron Menai Manor, Anglesey · <span className="text-[#f0dbbe] font-semibold">£49</span></p>
            <p className="text-[#9c8c7a] text-xs mt-2">Your invitation is personal and reserves one place.</p>
          </div>
        </div>
      </section>

      {/* INTRO */}
      <section className="px-6 py-16 max-w-2xl mx-auto space-y-5 text-[#d8cabb] text-base leading-relaxed">
        <p>We're bringing together 40 people from across Anglesey and North Wales who we think are doing genuinely interesting things. Founders, business owners, creatives, investors and people helping shape the area in different ways.</p>
        <p className="feral-serif text-[#ebc754] text-2xl">This isn't traditional networking.</p>
        <p>No pitching. No going around the room introducing ourselves. No collecting business cards for the sake of it.</p>
        <p>Grace &amp; James will serve three small plates throughout the evening. As each course arrives, we'll mix things up, sit with someone different and start another conversation. Later in the evening the structure disappears and everyone is free to return to the conversations they want to continue.</p>
      </section>

      {/* FERAL CONVERSATION */}
      <section className="px-6 pb-16">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 items-center">
          <img src="/innovators-talk.png" alt="Tom in conversation" className="w-full h-80 object-cover rounded-xl" />
          <div>
            <p className="text-[#ebc754] tracking-[0.2em] text-xs font-bold uppercase mb-3">The FERAL Conversation</p>
            <p className="text-[#d8cabb] leading-relaxed mb-3">During the evening, Tom will sit down with Robin from Dylan's for an informal conversation about building an ambitious business in North Wales.</p>
            <p className="text-[#d8cabb] leading-relaxed">The risks. The mistakes. The growth. What worked, what didn't, and what it really takes to create something here. Nothing too polished — just an honest conversation, followed by questions from the room.</p>
          </div>
        </div>
      </section>

      {/* ITINERARY */}
      <section className="px-6 pb-16">
        <div className="max-w-2xl mx-auto">
          <h2 className="feral-serif text-[#f0dbbe] text-4xl mb-8 text-center">The evening</h2>
          <div className="space-y-5">
            {ITINERARY.map(([t, title, desc]) => (
              <div key={t} className="flex gap-5">
                <div className="text-[#ebc754] font-bold text-sm w-20 shrink-0 pt-0.5">{t}</div>
                <div><p className="text-[#f0dbbe] font-semibold mb-1">{title}</p><p className="text-[#b6a897] text-sm leading-relaxed">{desc}</p></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FOOD */}
      <section className="px-6 pb-16 max-w-2xl mx-auto text-center">
        <h2 className="feral-serif text-[#f0dbbe] text-3xl mb-4">Food, drinks &amp; good conversation</h2>
        <p className="text-[#d8cabb] leading-relaxed">Grace &amp; James serve three small plates and dessert throughout the evening. BAA BAA Bar look after the drinks. Your ticket includes one mocktail on arrival; additional mocktails can be purchased from BAA BAA Bar throughout the evening. Food isn't a break from the networking — it's part of it.</p>
      </section>

      <InnovatorsCarousel />

      {/* PERSONAL INVITATION */}
      <section className="px-6 pb-16 max-w-2xl mx-auto">
        <div className="border border-[#4a3b31] rounded-xl p-6 text-[#c9bcab] text-sm leading-relaxed">
          <p className="text-[#ebc754] tracking-[0.2em] text-xs font-bold uppercase mb-3">Your invitation</p>
          FERAL Innovators invitations are personal and admit one guest only. We're deliberately curating the mix of people in the room, so there are no +1 event tickets. If there's someone you think should be part of FERAL Innovators, send them the <Link to="/events/feral-innovators" className="text-[#ebc754] underline">public event page</Link> and ask them to request an invitation.
        </div>
      </section>

      {/* CHECKOUT */}
      <section id="confirm" className="px-6 pb-24">
        <div className="max-w-2xl mx-auto">
          <h2 className="feral-serif text-[#f0dbbe] text-4xl mb-2 text-center">Confirm your place</h2>
          <p className="text-[#c9bcab] text-sm text-center mb-8">FERAL Innovators · Tuesday 10 November 2026 · 1 guest · £49</p>
          <form onSubmit={pay} className="bg-[#2c6052] border border-[#4a3b31] rounded-xl p-6 md:p-8 space-y-4" data-testid="invite-checkout">
            <div className="grid sm:grid-cols-2 gap-4">
              <input className={field} placeholder="Full name *" value={f.name} onChange={(e) => set("name", e.target.value)} data-testid="co-name" />
              <input className={field} type="email" placeholder="Email *" value={f.email} onChange={(e) => set("email", e.target.value)} data-testid="co-email" />
              <input className={field} placeholder="Mobile *" value={f.mobile} onChange={(e) => set("mobile", e.target.value)} data-testid="co-mobile" />
              <input className={field} placeholder="Company / organisation *" value={f.company} onChange={(e) => set("company", e.target.value)} data-testid="co-company" />
            </div>
            <input className={field} placeholder="Dietary requirements / allergies" value={f.dietary} onChange={(e) => set("dietary", e.target.value)} data-testid="co-dietary" />
            <div className="grid sm:grid-cols-2 gap-4">
              <input className={field} placeholder="Job title / role" value={f.job_title} onChange={(e) => set("job_title", e.target.value)} />
              <input className={field} placeholder="Website" value={f.website} onChange={(e) => set("website", e.target.value)} />
            </div>
            <textarea className={`${field} min-h-[70px]`} placeholder="What are you building or working on at the moment?" value={f.building} onChange={(e) => set("building", e.target.value)} />
            <textarea className={`${field} min-h-[70px]`} placeholder="What would be a useful connection for you right now?" value={f.useful_connection} onChange={(e) => set("useful_connection", e.target.value)} />
            <textarea className={`${field} min-h-[70px]`} placeholder="Is there something you could help someone else in the room with?" value={f.can_help} onChange={(e) => set("can_help", e.target.value)} />

            {/* Accommodation */}
            <div className="pt-2">
              <p className="text-[#f0dbbe] font-semibold mb-1">Stay the night <span className="text-[#8a7968] font-normal text-sm">(optional)</span></p>
              <p className="text-[#9c8c7a] text-xs mb-3">A few bedrooms at Bron Menai. All stays include the sauna and spa after the evening. Check-in from 5pm, check-out by 10am. Per bedroom for one night.</p>
              <div className="space-y-2">
                <label className="flex items-center justify-between gap-3 border border-[#4a3b31] rounded-md px-4 py-3 cursor-pointer">
                  <span className="flex items-center gap-3"><input type="radio" name="room" checked={accommodation === ""} onChange={() => setAccommodation("")} /> No room, thanks</span>
                </label>
                {Object.entries(rooms).map(([k, r]) => {
                  const out = r.remaining <= 0;
                  return (
                    <label key={k} className={`flex items-center justify-between gap-3 border border-[#4a3b31] rounded-md px-4 py-3 ${out ? "opacity-45 cursor-not-allowed" : "cursor-pointer"}`} data-testid={`room-${k}`}>
                      <span className="flex items-center gap-3"><input type="radio" name="room" disabled={out} checked={accommodation === k} onChange={() => setAccommodation(k)} /> {r.label}</span>
                      <span className="text-right">
                        <span className={`font-semibold ${out ? "text-[#8a7968] line-through" : "text-[#ebc754]"}`}>£{r.price}</span>
                        <span className="block text-[11px] text-[#9c8c7a] whitespace-nowrap" data-testid={`room-${k}-left`}>{out ? "Fully booked" : `${r.remaining} ${r.remaining === 1 ? "room" : "rooms"} left`}</span>
                      </span>
                    </label>
                  );
                })}
              </div>
              {accommodation && <input className={`${field} mt-3`} placeholder="Partner name (if staying)" value={f.partner_name} onChange={(e) => set("partner_name", e.target.value)} />}
              {accommodation && <input className={`${field} mt-3`} placeholder="Emergency contact" value={f.emergency_contact} onChange={(e) => set("emergency_contact", e.target.value)} />}
            </div>

            <label className="flex items-start gap-3 text-sm text-[#c9bcab] cursor-pointer">
              <input type="checkbox" checked={f.newsletter_consent} onChange={(e) => set("newsletter_consent", e.target.checked)} className="mt-1" />
              <span><strong className="text-[#f0dbbe]">Keep me in the FERAL loop.</strong> Occasional news about FERAL happenings.</span>
            </label>
            <label className="flex items-start gap-3 text-sm text-[#c9bcab] cursor-pointer">
              <input type="checkbox" checked={f.photo_consent} onChange={(e) => set("photo_consent", e.target.checked)} className="mt-1" data-testid="co-photo-consent" />
              <span><strong className="text-[#f0dbbe]">Photography *</strong> We'll have a photographer capturing the evening. I'm happy for photos of me to be taken and used on the FERAL website and social channels.</span>
            </label>
            <label className="flex items-start gap-3 text-sm text-[#c9bcab] cursor-pointer">
              <input type="checkbox" checked={f.accept_terms} onChange={(e) => set("accept_terms", e.target.checked)} className="mt-1" data-testid="co-terms" />
              <span>Your invitation is personal and admits one guest. Tickets are non-refundable. If you can no longer attend, please contact us rather than passing your ticket to someone else.</span>
            </label>

            {error && <p className="text-[#f0a868] text-sm">{error}</p>}
            <div className="flex items-center justify-between pt-2">
              <span className="feral-serif text-[#f0dbbe] text-3xl">£{total}</span>
              <button type="submit" disabled={submitting} data-testid="co-pay" className="bg-[#ebc754] hover:bg-[#b9772c] disabled:opacity-60 text-[#1b1512] font-bold tracking-[0.1em] uppercase text-sm px-8 py-4 transition-colors">
                {submitting ? "Taking you to payment…" : "Confirm my place"}
              </button>
            </div>
          </form>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default InnovatorsInvite;
